import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { useAuth, apiErr } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function AdminLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (!["owner", "admin"].includes(u.role)) {
        await logout();
        setError("This account is not an owner account. Please use the client or staff sign-in.");
        return;
      }
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      setError(apiErr(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Owner sign in" sub="Secure access to the Masaya owner portal."
      footer={<>Not the owner? <Link to="/login" className="text-[#B87333] font-medium hover:underline" data-testid="to-client-login">Client sign-in</Link> · <Link to="/" className="hover:underline">Back to site</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
        <div className="flex items-center gap-2 text-sm text-[#635B52] bg-[#F5F0E8] rounded-xl px-3 py-2">
          <ShieldCheck size={16} className="text-[#B87333]" /> Owners &amp; admins only
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" />
        </div>
        <div>
          <label className="text-sm font-medium text-[#2C2621]">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className={btnCls} data-testid="admin-login-submit">{loading ? "Signing in…" : "Sign in to portal"}</button>
        <div className="text-center">
          <Link to="/forgot-password" className="text-sm text-[#635B52] hover:text-[#B87333]" data-testid="admin-to-forgot">Forgot password?</Link>
        </div>
      </form>
    </AuthShell>
  );
}
